export function PrivacyPage() {
  return (
    <div className="page article-page">
      <header className="article-hero">
        <span className="eyebrow">隐私说明</span>
        <h1>你的选择留在当前浏览器里。</h1>
        <p>这个帮助页不要求登录，也不会要求你提供账号密码。</p>
      </header>
      <div className="privacy-grid">
        <section>
          <h2>不会收集</h2>
          <ul>
            <li>谷歌邮箱、密码或验证码</li>
            <li>兑换链接或聊天截图</li>
            <li>银行卡、付款资料内容</li>
            <li>诊断摘要正文</li>
          </ul>
        </section>
        <section>
          <h2>匿名统计</h2>
          <p>只统计访问了哪类问题、最终结果类型，以及是否复制摘要。统计失败不会影响排查。</p>
        </section>
        <section>
          <h2>本地会话</h2>
          <p>为了返回上一步或刷新后继续，当前进度会暂存在浏览器会话中；关闭浏览器会话后可自动清除。</p>
        </section>
      </div>
    </div>
  );
}
